import api from './api';
import { API_ENDPOINTS } from '../utils/constants';

export const setToken = (token) => {
  localStorage.setItem('token', token);
};

export const getToken = () => {
  return localStorage.getItem('token');
};

export const removeToken = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
};

export const setUser = (user) => {
  localStorage.setItem('user', JSON.stringify(user));
};

export const getUser = () => {
  const user = localStorage.getItem('user');
  return user ? JSON.parse(user) : null;
};

export const isAuthenticated = () => {
  return !!getToken();
};

export const login = async (email, password) => {
  try {
    const response = await api.post(API_ENDPOINTS.LOGIN, { email, password });
    const { access_token } = response.data;
    setToken(access_token);
    
    // Get user details
    const userResponse = await api.get(API_ENDPOINTS.ME);
    setUser(userResponse.data);
    
    return { success: true, user: userResponse.data };
  } catch (error) {
    return { 
      success: false, 
      error: error.response?.data?.detail || 'Login failed' 
    };
  }
};

export const register = async (userData) => {
  try {
    const response = await api.post(API_ENDPOINTS.REGISTER, userData);
    return { success: true, user: response.data };
  } catch (error) {
    return { 
      success: false, 
      error: error.response?.data?.detail || 'Registration failed' 
    };
  }
};

export const logout = () => {
  removeToken();
};

export const getCurrentUser = async () => {
  try {
    const response = await api.get(API_ENDPOINTS.ME);
    return { success: true, user: response.data };
  } catch (error) {
    return { success: false, error: error.response?.data?.detail };
  }
};